import React, { Fragment } from "react";

import banner2 from "../../assets/images/banner2.jpg";
import banner7 from "../../assets/images/banner7.png";
import { ButtonLink } from "../../components/ButtonLink/ButtonLink";
import { ConsultationBanner } from "../../components/ConsultationBanner/ConsultationBanner";
import { FAQSection } from "../../components/FAQSection/FAQSection";
import { OutcomeSection } from "../../components/OutcomeSection/OutcomeSection";
import { ResultSection } from "../../components/ResultSection/ResultSection";
import { ReviewSection } from "../../components/ReviewSection/ReviewSection";
import { ServiceBannerSection } from "../../components/ServiceBannerSection/ServiceBannerSection";
import { TargetAudienceSection } from "../../components/TargetAudienceSection/TargetAudienceSection";
import { TariffSection } from "../../components/TariffSection/TariffSection";
import { WorkflowSection } from "../../components/WorkflowSection/WorkflowSection";
import { faqData } from "../../config/faqData";
import { outcomeData } from "../../config/outcomeData";
import { resultData } from "../../config/resultData";
import { targetAudienceData } from "../../config/targetAudienceData";
import { workflowData } from "../../config/workflowData";
import { usePageData } from "../../hooks/usePageData";
import {
  Section,
  SmallTitle,
  TitleH2,
} from "../../styles/sharedStyles";

import { Container, CustomTitleH2 } from "./styles"

const target = targetAudienceData.it_hiring_page
const workflow = workflowData.it_hiring_page
const result = resultData.it_hiring_page
const faq = faqData.it_hiring_page
const { outcome, backgroundImage } = outcomeData.it_hiring_page

export const ITHiring = () => {
  const { card, productCategories, reviews: filteredReviews } = usePageData(8);

  const filteredProducts = card.filter(
    (item) => item.product_category.id === 13
  );

  return (
    <Fragment>
      <ServiceBannerSection
        mainText="Подбор специалистов"
        backgroundImage={banner7}
        descText="Поможем быстро и качественно закрыть открытые позиции за приемлемую стоимость."
      />
      <Section>
        <Container>
          <CustomTitleH2>Кому подходит <span>услуга?</span></CustomTitleH2>
          <TargetAudienceSection data={target} />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Как строится работа?</TitleH2>
          <WorkflowSection data={workflow} />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Что вы получите <span>в итоге ?</span></TitleH2>
          <OutcomeSection
            data={outcome}
            backgroundImage={backgroundImage}
          />
        </Container>
      </Section>
      <Section>
        <Container>
          <SmallTitle>тарифы</SmallTitle>
          <TitleH2>Как мы можем помочь</TitleH2>
          <TariffSection
            products={filteredProducts}
            color="#BCD3FF"
          />
        </Container>
      </Section>
      <Section>
        <Container>
          <TitleH2>Мы приносим <span>результат</span></TitleH2>
          <ResultSection data={result} />
        </Container>
      </Section>
      {filteredReviews.length > 0 && (
        <Section>
          <Container>
            <TitleH2>Отзывы</TitleH2>
            <ReviewSection
              reviews={filteredReviews}
              categories={productCategories}
            />
            <ButtonLink
              toPage="/reviews"
              title="Все отзывы"
            />
          </Container>
        </Section>
      )}
      <ConsultationBanner backgroundImage={banner2} />
      <Section>
        <Container>
          <FAQSection data={faq} />
        </Container>
      </Section>
    </Fragment>
  )
}
